import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';
import { Actions, Effect } from '@ngrx/effects';
import { uiOpenMainBarAction, uiToggleMainBarAction, uiCloseMainBarAction } from '../ui/index';
import { RouterService } from '../../core/service/core/router.sevice';
import { Observable } from "rxjs/Observable";

//state
export interface UserState {
  isAuth: boolean;
  token: string;
  data: any;
}

export const USER_STATE_INIT: UserState = {
  isAuth: false,
  token: '',
  data: {},
}

//constants
export const USER_LOGIN_ACTION = '[USER] LOGIN_ACTION';
export const USER_LOGOUT_ACTION = '[USER] LOGOUT_ACTION';
export const USER_SET_TOKEN_ACTION = '[USER] SET_TOKEN_ACTION';
export const USER_CLEAR_TOKEN_ACTION = '[USER] CLEAR_TOKEN_ACTION';

//actions
export function userLoginAction(payload: any): Action {
  return { type: USER_LOGIN_ACTION, payload }
}
export function userLogoutAction(): Action {
  return { type: USER_LOGOUT_ACTION }
}
export function userSetTokenAction(payload: string): Action {
  return { type: USER_SET_TOKEN_ACTION, payload };
}
export function userClearTokenAction(): Action {
  return { type: USER_CLEAR_TOKEN_ACTION };
}

//reducer
export function userReducer(state: UserState = USER_STATE_INIT, action: Action): UserState {
  switch (action.type) {
    case USER_LOGIN_ACTION:
      return Object.assign({}, state, { data: action.payload, isAuth: true });
    case USER_LOGOUT_ACTION:
      return Object.assign({}, state, { data: null, isAuth: false });
    case USER_SET_TOKEN_ACTION:
      return Object.assign({}, state, { token: action.payload });
    case USER_CLEAR_TOKEN_ACTION:
      return Object.assign({}, state, { token: '' });
    default:
      return state;
  }
}

//effects
@Injectable()
export class UserEffect {

  constructor(private actions: Actions) { }

  @Effect()
  login$ = this.actions
    .ofType(USER_LOGIN_ACTION)
    .delay(1000)
    .map(() => uiOpenMainBarAction())

  @Effect()
  logout$ = this.actions
    .ofType(USER_LOGOUT_ACTION)
    .map(() => uiCloseMainBarAction())

}













// WEBPACK FOOTER //
// ./src/app/store/user/index.ts